import api from '../../services/api';

export interface WarehouseCorrectionSummary {
  id: string;
  createdAt: string;
  createdByName: string | null;
  reason: string;
}

export async function loadWarehouseCorrections(
  documentType: 'PZ' | 'WZ',
  id: string
): Promise<WarehouseCorrectionSummary[]> {
  const { data } = await api.get(
    `/${documentType.toLowerCase()}/${encodeURIComponent(id)}/corrections`
  );
  return Array.isArray(data) ? data : [];
}

export async function saveWZCorrection(
  id: string,
  payload: Record<string, unknown>,
  confirm: (warning: any) => Promise<boolean>
): Promise<boolean> {
  try {
    await api.put(`/wz/${encodeURIComponent(id)}`, payload);
  } catch (error: any) {
    const warning = error?.response?.data;
    if (warning?.code !== 'WZ_RELEASE_EXCEEDS_ORDERED_QUANTITY') throw error;
    if (!(await confirm(warning))) return false;
    await api.put(`/wz/${encodeURIComponent(id)}`, {
      ...payload,
      confirmExceedsOrderedQuantity: true,
      confirmationFingerprint: warning.confirmationFingerprint,
    });
  }
  return true;
}
